const options = {
  5: "bg-gray-800/5",
  10: "bg-gray-800/10",
  25: "bg-gray-800/25",
  50: "bg-gray-800/50",
  75: "bg-gray-800/75",
  90: "bg-gray-800/90",
  100: "bg-gray-800",
};

const from = {
  5: "from-gray-800/5",
  10: "from-gray-800/10",
  25: "from-gray-800/25",
  50: "from-gray-800/50",
  75: "from-gray-800/75",
  90: "from-gray-800/90",
  100: "from-gray-800",
};

export default function getBackgroundGray800(opacity, isFrom) {
  return (isFrom ? from : options)[opacity || 100];
}
